import LoadMore from '../classes/LoadMore';

class LoadMoresModule {
    constructor() {
        this.loadMores = [];

        this.initialize();
    }

    initialize() {
        this.bindUI();
        this.bindEvents();
        this.setLoadMores();
    }

    bindUI() {
        this.ui = {};

        this.ui.$loadMores = document.querySelectorAll('.js-loadmore');
    }

    bindEvents() {
        document.body.addEventListener('tab:loaded', this.onNeedsUpdate.bind(this));
    }

    onNeedsUpdate() {
        this.destroy();

        this.loadMores = [];
        this.bindUI();
        this.setLoadMores();
    }

    destroy() {
        if (this.loadMores.length) {
            this.loadMores.forEach((loadMore, index) => {
                loadMore.destroy();
            });
        }
    }

    setLoadMores() {
        [].forEach.call(this.ui.$loadMores, ($el, index) => {
            this.loadMores.push(
                new LoadMore({
                    $el
                })
            );
        });
    }
};

export default LoadMoresModule;
